export default "__VITE_PUBLIC_ASSET__df912ae6__"